import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'

const Content = styled.div`
    top:100px;
    position: absolute;
    width: 100%;
    padding-bottom: 8%;
`;
function BaseLayout({ header, children, footer }) {
    return (
        <>
            {header}
            <Content>
                {children}
            </Content>
            {footer}         
        </>
    )
}

BaseLayout.propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
    footer: PropTypes.node
}

export default BaseLayout

